import { useEffect, useState } from "react";
import api from "../api/client";
import { Alert } from "../components/Ui";

export default function AdminBanners() {
  const [banners, setBanners] = useState([]);
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [link, setLink] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const load = () => api.get("/product/banners").then((r) => setBanners(r.data.banners || [])).catch(() => {});

  useEffect(() => { load(); }, []);

  function handleImage(e) {
    const file = e.target.files[0];
    if (!file) return;
    setImage(file);
    setPreview(URL.createObjectURL(file));
  }

  async function upload() {
    if (!image) return setError("Select an image first.");
    setBusy(true); setError(null);
    try {
      const fd = new FormData();
      fd.append("image", image);
      fd.append("link", link);
      await api.post("/admin/banners", fd, { headers: { "Content-Type": "multipart/form-data" } });
      setImage(null); setPreview(null); setLink("");
      load();
    } catch (e) { setError(e.message); }
    finally { setBusy(false); }
  }

  async function remove(id) {
    if (!window.confirm("Delete this banner?")) return;
    try { await api.delete(`/admin/banners/${id}`); load(); }
    catch (e) { setError(e.message); }
  }

  return (
    <div>
      <h1>Banners / Hero Section</h1>
      <p className="muted small" style={{ marginBottom: 20 }}>
        These appear as the carousel on the home page. Recommended size: 1200×400px.
      </p>

      {/* Upload form */}
      <div className="card" style={{ padding: 20, marginBottom: 24 }}>
        <h3 style={{ fontSize: 14, margin: "0 0 12px" }}>Add new banner</h3>
        <div style={{ display: "flex", gap: 16, flexWrap: "wrap", alignItems: "flex-end" }}>
          <div>
            <label className="muted small" style={{ display: "block", marginBottom: 4 }}>Image *</label>
            <input type="file" accept="image/*" onChange={handleImage} />
          </div>
          <div style={{ flex: 1, minWidth: 200 }}>
            <label className="muted small" style={{ display: "block", marginBottom: 4 }}>Link URL (optional)</label>
            <input className="input" value={link} onChange={(e) => setLink(e.target.value)}
              placeholder="https://..." style={{ width: "100%" }} />
          </div>
          <button className="btn primary" onClick={upload} disabled={busy || !image}
            style={{ padding: "10px 20px" }}>
            {busy ? "Uploading…" : "Upload"}
          </button>
        </div>
        {preview && (
          <img src={preview} alt="Preview" style={{ marginTop: 12, width: "100%", maxWidth: 400, height: 120, objectFit: "cover", borderRadius: 12 }} />
        )}
        <Alert>{error}</Alert>
      </div>

      {/* Existing banners */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))", gap: 16 }}>
        {banners.map((b) => (
          <div key={b._id} className="card" style={{ overflow: "hidden" }}>
            <img src={`/${b.image}`} alt="" style={{ width: "100%", height: 140, objectFit: "cover", display: "block" }}
              onError={(e) => { e.target.style.background = "var(--ink-700)"; e.target.style.height = "80px"; }} />
            <div style={{ padding: 12, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <span className="muted small" style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: 180 }}>
                {b.link || "No link"}
              </span>
              <button className="btn ghost" style={{ padding: "4px 10px", fontSize: 11, color: "var(--bad)" }}
                onClick={() => remove(b._id)}>Delete</button>
            </div>
          </div>
        ))}
        {banners.length === 0 && <p className="muted">No banners yet. Upload one above.</p>}
      </div>
    </div>
  );
}